import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getRepairItemApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;
  const status = error?.response?.status;

  if (status === 404 || code === 'REPAIR_ITEM_NOT_FOUND') {
    return data?.message || '找不到維修品項';
  }

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  if (status === 409) {
    return data?.message || '此維修品項目前無法修改，已重新載入';
  }

  if (status >= 500) {
    return data?.message || '維修品項服務異常';
  }

  return data?.message || fallback;
}

/** 版本衝突或簽收鎖定：重讀明細，不自動重送。 */
export function isRepairItemRefetchError(error) {
  return error?.response?.status === 409;
}
